import { AppConfig } from 'app.config';
import { splitHash } from 'business-layer/helpers/splitHash';
import { GenericRequest } from "data-layer/types";

export const PaymentGatewayRequestService = (hash: string): GenericRequest => {
  const { payByLinkId } = splitHash(hash);
  return {
    url: AppConfig.gatewayConfigUrl!,
    method: AppConfig.useDummyData ? 'GET' : 'POST',
    data: { payByLinkId },
  }
};
